import { AuthFetch } from "../hooks/useApi";
import { GerarReferenciasResumoRequest, ItemRecurso, OpmeBundle, ProcedimentoBundle } from "../types/resources.types";

export type ReferenceTarget = "CODIGO" | "MATERIAL";

type SummaryReferencesResponse = { referencias?: { procedimentos?: ProcedimentoBundle[]; opmes?: OpmeBundle[] } };

const PATH: Record<ReferenceTarget | "all", string> = {
  all: "/resumo/referencias",
  CODIGO: "/resumo/referencias/procedimentos",
  MATERIAL: "/resumo/referencias/opmes",
};

// A pesquisa do Gemini passa de 60s (o padrão do useApi); o backend desiste em 280s.
const AI_TIMEOUT_MS = 300_000;

const itemsOf = (items: ItemRecurso[] | undefined, tipo: ReferenceTarget) =>
  items?.filter((i) => i.tipo === tipo).map(({ id, descricao, tipo, status }) => ({ id, descricao, tipo, status }));

/** Sem `target`, manda procedimentos e OPME; com `target`, só os itens daquele tipo. */
export function summaryReferencesPayload(description: string, items: ItemRecurso[] | undefined, email?: string, target?: ReferenceTarget): GerarReferenciasResumoRequest {
  const payload: GerarReferenciasResumoRequest = { descricao_paciente: description };
  if (target !== "MATERIAL") payload.procedimentos = itemsOf(items, "CODIGO");
  if (target !== "CODIGO") payload.opmes = itemsOf(items, "MATERIAL");
  if (email !== undefined) payload.email = email;
  return payload;
}

export const referencesService = {
  /** Referências bibliográficas do resumo, por procedimento e por OPME. */
  summary: (apiFetch: AuthFetch, payload: GerarReferenciasResumoRequest, target?: ReferenceTarget) =>
    apiFetch<SummaryReferencesResponse>(PATH[target ?? "all"], { method: "POST", body: JSON.stringify(payload), signal: AbortSignal.timeout(AI_TIMEOUT_MS) }),
};
